import React from 'react';
import {ICompetitorOdds} from '../../../api/outright-odds';
import bn from "../../../utils/bemnames";
import {findBestOddsFromOddsArray, sortProvidersByPromotedProvider} from '../../../utils/odds';
import {IOdds, IProvider, oddsFormats} from '../../../utils/types';
import EventDataMobile from './EventDataMobile';
import OddsButtonWithoutOperator from "../../Buttons/OddsButtonWithoutOperator";
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
import {useGlobalState} from "../../../contexts/GlobalState";

interface IProps {
  key: number
  competitorOdd: ICompetitorOdds,
  languageId: number,
  allowedProvidersIds: number[],
  outRightOddsProviders: IProvider[],
  outLinkFolder: string|null|undefined,
  oddsFormat: oddsFormats,
  widgetId: number,
  builderComponentId?: number,
}

const bem = bn.create('outright-odds-mobile');

const CompetitorRowMobile: React.FC<IProps> = ({
  key,
  competitorOdd,
  languageId,
  outRightOddsProviders,
  oddsFormat,
  outLinkFolder,
  widgetId,
  builderComponentId = undefined,
  allowedProvidersIds = [],
}) => {
  const bestProviderIDs = findBestOddsFromOddsArray(competitorOdd.outRightOddsData.odds).map((odds: IOdds) => odds.providerId)
  const {globalState} = useGlobalState()

  return (
    <AccordionItem className={bem.e('row')} key={key}>
      <AccordionItemHeading>
        <AccordionItemButton>
          <div className={bem.e('competitor')}>
            <div className={bem.e('competitor__info')}>
              <div className={bem.e('competitor__info-name')}>
                {competitorOdd.competitor.trName}
              </div>
            </div>
            <div className={bem.e('competitor__odds')}>
              {sortProvidersByPromotedProvider(outRightOddsProviders, globalState.promotedProvider).map((provider, index) => {
                const odds: IOdds | undefined = competitorOdd.outRightOddsData.odds.find(odds => odds.providerId === provider.id)
                return (
                  <div className={bem.e('competitor__odds-item')} key={index}>
                    <OddsButtonWithoutOperator
                      isMobile={true}
                      odds={odds ?? null}
                      provider={provider}
                      oddsFormat={oddsFormat}
                      outLinkPath={outLinkFolder ?? ''}
                      widgetId={widgetId}
                      builderComponentId={builderComponentId}
                      hasBorder={odds ? bestProviderIDs.includes(odds.providerId) : false}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel>
        {competitorOdd.outRightOddsData.nextEvent && (
          <EventDataMobile
            eventId={competitorOdd.outRightOddsData.nextEvent.id}
            competitorId={competitorOdd.competitor.id}
            languageId={languageId}
            allowedProvidersIds={allowedProvidersIds}
            widgetId={widgetId}
            outLinkFolder={outLinkFolder}
            oddsFormat={oddsFormat}
          />
        )}
      </AccordionItemPanel>
    </AccordionItem>
  )
}

export default CompetitorRowMobile;
